import { createSelector } from "@reduxjs/toolkit";

import { EMPTY_POLICY } from "./allowedSitesSlice";

export const selectAllowedSites = (state) => state.sharepointAllowedSites;
export const selectAllowedSitesPolicy = (state) =>
  selectAllowedSites(state).policy || EMPTY_POLICY;
export const selectAllowedSitesDraft = (state) =>
  selectAllowedSites(state).draft;
export const selectAllowedSitesDiscovery = (state) =>
  selectAllowedSites(state).discovery;
export const selectIsAllowedSitesAuthenticated = (state) =>
  selectAllowedSites(state).isAuthenticated;

const sortedIds = (sites) =>
  sites
    .map((site) => site.id)
    .sort()
    .join("|");

export const selectIsAllowedSitesDraftDirty = createSelector(
  [selectAllowedSitesPolicy, selectAllowedSitesDraft],
  (policy, draft) =>
    policy.restricted !== draft.restricted ||
    sortedIds(policy.sites) !== sortedIds(draft.sites)
);

export const selectDraftSiteIds = createSelector(
  [selectAllowedSitesDraft],
  (draft) => new Set(draft.sites.map((site) => site.id))
);
